/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description HOC for geoLocation
 */

import hoistStatics from 'hoist-non-react-statics'
import React from 'react'
import type { GetProps, InferableComponentEnhancerWithProps } from 'react-redux'
import useGeoLocation from './useGeoLocation'

// @ts-expect-error
const withGeoLocation: InferableComponentEnhancerWithProps<
  {
    getGeoLocation: ReturnType<typeof useGeoLocation>[0]
    isSafeForClientOnly: ReturnType<typeof useGeoLocation>[1]
  },
  {}
> = (WrappedComponent) => {
  const WithGeoLocation = (props: GetProps<typeof WrappedComponent>) => {
    const [getGeoLocation, isSafeForClientOnly] = useGeoLocation()
    return (
      // @ts-expect-error
      <WrappedComponent
        {...props}
        getGeoLocation={getGeoLocation}
        isSafeForClientOnly={isSafeForClientOnly}
      />
    )
  }
  WithGeoLocation.displayName = `withGeoLocation(${
    // @ts-expect-error displayName doesn't exist
    WrappedComponent.displayName || WrappedComponent.name
  })`
  WithGeoLocation.WrappedComponent = WrappedComponent
  hoistStatics(WithGeoLocation, WrappedComponent)
  return WithGeoLocation
}

export default withGeoLocation
